import React from 'react';
import ToolMark from './ToolMark';
import ColorPickerToolButton from '../../../components/ColorPicker/ColorPickerToolButton/ColorPickerToolButton';
import { type ToolbarSubmenuProps } from '../../../types/aha-editor';

// Toggles a text color mark (color style) on the currently selected elements.
class ToolTextColor extends ToolMark {
  static toolName = 'Text color';
  static iconClass = 'fa-regular fa-font';
  static mark = 'textColor' as const;

  static toolbarSubmenu() {
    return function TextColorPickerToolButton(
      props: ToolbarSubmenuProps<typeof ToolTextColor>
    ) {
      return <ColorPickerToolButton {...props} showClearButton={false} />;
    };
  }
}

export default ToolTextColor;
